export type ComplianceLevel = 'bad' | 'warn' | 'ok';

/** Rojo < 85 %, ámbar 85–92 %, verde >= 92 %. */
export const complianceLevel = (pct: number): ComplianceLevel => {
  if (pct < 85) return 'bad';
  if (pct < 92) return 'warn';

  return 'ok';
};

/** Ejecutadas sobre planificadas, con un decimal. Sin planificadas es 0. */
export const compliancePct = (executed: number, planned: number): number =>
  planned > 0 ? Math.round((executed / planned) * 1000) / 10 : 0;

/**
 * Visited stops (executed + incidents) over planned, one decimal. Pending
 * does not count. Without planned it is 0, like `compliancePct`.
 */
export const coveragePct = (
  executed: number,
  incidents: number,
  planned: number
): number =>
  planned > 0 ? Math.round(((executed + incidents) / planned) * 1000) / 10 : 0;

/** El % de incidencias va en rojo solo sobre 10 %. */
export const incidentPctIsHigh = (pct: number): boolean => pct > 10;
